import React, { useState, useContext } from "react";
import { Helmet } from "react-helmet-async";
import helpTranslations from "../locales/helpTranslations";
import { LanguageContext } from "../locales/LanguageContext";

const Help = () => {
  const { lang } = useContext(LanguageContext);
  const t = helpTranslations[lang] || {};
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <Helmet>
        <title>AKAAL KIDS | {t.pageTitle || "Help & FAQ"}</title>
      </Helmet>
      {/* Hero Banner */}
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 4px 24px #f6815e22",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 8,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.heroTitle}
        </h1>
        <div style={{ fontSize: 20, fontWeight: 500, opacity: 0.96 }}>
          <span role="img" aria-label="help">
            ❓
          </span>{" "}
          {t.heroDesc}
        </div>
      </div>
      <div
        className="container"
        style={{ fontSize: "1.18em", marginTop: -18, marginBottom: 24 }}
      >
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div
              className="card border-0 shadow-lg p-5 mb-5"
              style={{ borderRadius: 18 }}
            >
              <h2
                style={{
                  color: "#f6815e",
                  fontWeight: 700,
                  marginBottom: 32,
                  textAlign: "center",
                }}
              >
                {t.faqTitle}
              </h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {(t.faqs || []).map((faq, idx) => (
                  <li
                    key={idx}
                    style={{
                      borderBottom: "1px solid #eee",
                      padding: "24px 0",
                    }}
                  >
                    <div
                      onClick={() =>
                        setActiveIndex(activeIndex === idx ? null : idx)
                      }
                      style={{
                        fontWeight: 700,
                        fontSize: "1.25rem",
                        color: "#b26a00",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{ display: "flex", alignItems: "flex-start" }}
                      >
                        <span
                          style={{
                            color: "#f6b93b",
                            fontSize: "1.5rem",
                            marginRight: 12,
                            lineHeight: 1,
                          }}
                        >
                          Q.
                        </span>
                        {faq.question}
                      </div>
                      <span
                        style={{
                          transform:
                            activeIndex === idx
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          transition: "transform 0.3s",
                          color: "#f6815e",
                          fontSize: "1.2rem",
                        }}
                      >
                        ▼
                      </span>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateRows: activeIndex === idx ? "1fr" : "0fr",
                        transition:
                          "grid-template-rows 0.4s ease-out, opacity 0.4s ease-out",
                        opacity: activeIndex === idx ? 1 : 0,
                      }}
                    >
                      <div style={{ overflow: "hidden" }}>
                        <div
                          style={{
                            color: "#444",
                            fontSize: "1.1rem",
                            marginLeft: 36,
                            marginTop: 16,
                            lineHeight: 1.6,
                          }}
                        >
                          {(faq.answer || []).length > 1 ? (
                            <ul style={{ marginTop: 8, marginBottom: 8 }}>
                              {faq.answer.map((ans, i) => (
                                <li key={i}>{ans}</li>
                              ))}
                            </ul>
                          ) : (
                            <span>{faq.answer[0]}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            {/* Personal Assistance & Commitment Section */}
            <div className="row g-4 mb-5">
              <div className="col-md-6">
                <div
                  className="card h-100 border-0 shadow-sm p-4"
                  style={{ borderRadius: 18, background: "#fffbe6" }}
                >
                  <h3
                    style={{
                      color: "#b26a00",
                      fontWeight: 700,
                      marginBottom: 16,
                    }}
                  >
                    {t.assistanceTitle}
                  </h3>
                  <p style={{ fontSize: "1.1rem", color: "#444" }}>
                    {t.assistanceDesc}
                  </p>
                  <div style={{ marginTop: 20 }}>
                    <div style={{ marginBottom: 10, fontSize: "1.1rem" }}>
                      <span role="img" aria-label="email">
                        📩
                      </span>{" "}
                      <strong>Email:</strong>{" "}
                      <a
                        href={`mailto:${t.contact?.email}`}
                        style={{ color: "#f6815e", textDecoration: "none" }}
                      >
                        {t.contact?.email}
                      </a>
                    </div>
                    <div style={{ marginBottom: 10, fontSize: "1.1rem" }}>
                      <span role="img" aria-label="whatsapp">
                        📱
                      </span>{" "}
                      <strong>WhatsApp:</strong>{" "}
                      <a
                        href={`https://wa.me/${t.contact?.whatsapp.replace(/\D/g, "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#25D366", textDecoration: "none" }}
                      >
                        {t.contact?.whatsapp}
                      </a>
                    </div>
                    <div style={{ fontSize: "1.1rem" }}>
                      <span role="img" aria-label="website">
                        🌐
                      </span>{" "}
                      <strong>Website:</strong>{" "}
                      <a
                        href={`https://${t.contact?.website}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1976d2", textDecoration: "none" }}
                      >
                        {t.contact?.website}
                      </a>
                    </div>
                  </div>
                  <p
                    style={{
                      marginTop: 20,
                      fontStyle: "italic",
                      color: "#666",
                    }}
                  >
                    {t.assistanceNote}
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div
                  className="card h-100 border-0 shadow-sm p-4"
                  style={{
                    borderRadius: 18,
                    background:
                      "linear-gradient(135deg, #f6815e 0%, #f6b93b 100%)",
                    color: "#fff",
                  }}
                >
                  <h3 style={{ fontWeight: 700, marginBottom: 16 }}>
                    {t.commitmentTitle}
                  </h3>
                  <p style={{ fontSize: "1.2rem", fontWeight: 500 }}>
                    {t.commitmentDesc}
                  </p>
                  <ul
                    style={{
                      fontSize: "1.15rem",
                      listStyle: "none",
                      padding: 0,
                    }}
                  >
                    {(t.commitmentPoints || []).map((point, idx) => (
                      <li style={{ marginBottom: 8 }} key={idx}>
                        ✨ {point}
                      </li>
                    ))}
                  </ul>
                  <p
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: 700,
                      marginTop: 16,
                    }}
                  >
                    {t.commitmentFinal}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Help;
